module.exports = __webpack_public_path__ + "img/icon_mid_en_shadow.85edf245.png";